<template>
	<div class='search-article-wrap'>
		<div class="nav-wrap">
			<div class="flex">
				<i class="iconfont icon-home1"></i>
				<router-link class="link" to="/">首页</router-link>
				<i class="el-icon-arrow-right"></i>
				<router-link class="link" to="/">资讯文章</router-link>
				<i class="el-icon-arrow-right"></i>
				<span class="link"><span>资讯文章</span></span>
			</div>
		</div>
		<main>
			<div class="search-title">
				已为您按照
				<span>“{{keywords}}”</span>筛选文章，共筛选出<span>&nbsp;{{total}}&nbsp;</span>条数据
			</div>
			<ul class="wrap-border">
				<li v-for="item in list" :key="item.id">
					<router-link :to="`/common/article/${formatType(item)}/${item.id}`" tag="a">
						<div class="flex" :title="item.title">
							<p class="ellipsis-1" v-html="item.matchTitle"></p>
							<p class="ellipsis-1 source-wrap flex flex-row-end"><span class="source">来源</span><span>{{item.source}}</span></p>
							<p>{{item.publishTime}}</p>
						</div>
						<div class="list-brief ellipsis-3">{{item.description}}</div>
					</router-link>
				</li>
			</ul>
			<div class="page-wrap">
				<el-pagination background layout="total, prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />
			</div>

		</main>
	</div>
</template>

<script>
import { searchArticle } from '@/api';
export default {
	components: {},
	data() {
		return {
			keywords: undefined,
			list: [],
			total: 0,
			pageSize: 10
		}
	},
	created() { },
	mounted() {

	},
	methods: {
		getNewsSearch(page = 1) {
			searchArticle({ keyword: this.keywords, current: page }).then(res => {
				const { total, records, size, current } = res;
				this.$set(this, 'total', total || 0);
				this.$set(this, 'pageSize', size || 10);
				this.$set(this, 'list', (records || []).map(item => Object.assign({}, item,
					{ matchTitle: item.title.replace(this.keywords, `<strong>${this.keywords}</strong>`) })));
			})
		},
		handleCurrentChange(e) {
			this.getNewsSearch(e)
		},
		formatType(row) {
			const { type } = row;
			// 1信用动态，2行业信用，3诚信宣传，4政策法规，5信用研究，6专项治理,7风险提示,8联合奖惩,9通知公告
			switch (type) {
				case '信用动态':
					return 1;
				case '行业信用':
					return 2;
				case '诚信宣传':
					return 3;
				case '政策法规':
					return 4;
				case '信用研究':
					return 5;
				case '专项治理,':
					return 6;
				case '风险提示':
					return 7;
				case '联合奖惩':
					return 8;
				case '通知公告':
					return 9;
				default:
					break;
			}
		}
	},
	computed: {},
	watch: {
		$route: {
			handler(v) {
				const { query: { keywords } } = v;
				if (keywords) {
					this.$set(this, 'keywords', keywords);
					this.getNewsSearch()
				}
			},
			deep: true,
			immediate: true
		},
	},
	filters: {
		sliceBrief(brief) {
			if (brief && brief.length > 145) {
				return brief.slice(0, 145) + '...';
			} else {
				return brief;
			}
		}
	}
}
</script>
<style lang='scss'>
	.search-article-wrap {
		& > main {
			width: 1280px;
			margin: 0 auto;
			& > .search-title {
				padding-top: 35px;
				text-indent: 16px;
				font-size: 16px;
				line-height: 34px;
				text-align: left;
				& > span {
					color: $red;
				}
			}
			& > .page-wrap {
				padding: 40px 0;
				text-align: right;
			}
			& > .wrap-border {
				padding: 0 16px;
				& > li {
					border-bottom: 1px solid #e3e7ea;
					padding: 20px 0 35px;
					&:last-child {
						border: none;
					}
					& .list-brief {
						width: 735px;
						font-size: 14px;
						text-align: left;
					}
					& > a {
						& > .flex {
							margin-bottom: 10px;
							& > p {
								&:first-of-type {
									width: 70%;
									font-size: 16px;
									cursor: pointer;
									text-align: left;
									& > strong {
										color: $red;
									}
								}
								&:last-of-type {
									height: 16px;
									line-height: 16px;
									font-size: 14px;
									padding: 0 5px;
									vertical-align: text-bottom;
								}
							}
							& > .source-wrap {
								width: calc(100% - 70% - 82px);
								& > span {
									height: 16px;
									line-height: 16px;
									font-size: 14px;
									padding: 0 5px;
									vertical-align: middle;
									border-right: 2px solid #707070;
									&.source {
										color: #fff;
										background: $red;
										padding: 0 5px;
										border-radius: 3px;
										font-size: 12px;
										border: none;
										flex-shrink: 0;
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>